module.exports = __webpack_public_path__ + "img/step1-3.24e330cd.png";